export default "__VITE_ASSET__BPw494je__"